"use client";

import Image from "next/image";
import React from "react";
import square_shape_bottom from "@/assets/img/bg/square-shape-bottom.png";

const MuseAboutInfo = () => {
  return (
    <section id="about">
      <div id="about-info-area" className="ab-info__area pb-50 p-relative">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="ab-info__text">
                <div>
                  {
                    "You’re the expert. I’m your muse, Marie Ellis. With 15+ years’ experience, I'm a Sunday Times number 1 bestselling "
                  }
                  <b>ghostwriter</b> and <b>editor</b>
                  {" for books, I’ve led content strategies at "}
                  <b>top health publishers</b>
                  {" and in "}
                  <b>high-growth startups</b>
                  {", and I’ve "}
                  <b>managed content teams</b>
                  {" to great success."}
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div className="ab-hero__shape-2">
          <Image src={square_shape_bottom} alt="image-here" />
        </div>
      </div>
    </section>
  );
};

export default MuseAboutInfo;
